import { Alert, Snackbar } from "@mui/material";
import React from "react";

const severityStyles = {
  success: {
    background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
    shadow: "0 12px 28px rgba(22, 163, 74, 0.35)",
    border: "1px solid rgba(34, 197, 94, 0.35)",
  },
  error: {
    background: "linear-gradient(135deg, #f87171 0%, #ef4444 100%)",
    shadow: "0 12px 28px rgba(239, 68, 68, 0.35)",
    border: "1px solid rgba(239, 68, 68, 0.35)",
  },
  warning: {
    background: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
    shadow: "0 12px 28px rgba(251, 191, 36, 0.35)",
    border: "1px solid rgba(251, 191, 36, 0.35)",
  },
  info: {
    background: "linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)",
    shadow: "0 12px 28px rgba(59, 130, 246, 0.35)",
    border: "1px solid rgba(96, 165, 250, 0.35)",
  },
};

export default function WarningSnackbar({
  open,
  autoHideDuration,
  onClose,
  message,
  severity = "info",
}) {
  const style = severityStyles[severity] || severityStyles.info;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{
        "& .MuiSnackbarContent-root": {
          p: 0,
          borderRadius: 3,
          boxShadow: style.shadow,
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="outlined"
        sx={{
          width: "100%",
          color: "#fff",
          background: style.background,
          borderRadius: 3,
          border: style.border,
          boxShadow: "none",
          alignItems: "center",
          fontWeight: 600,
          letterSpacing: 0.3,
          px: 2.5,
          py: 1.5,
          "& .MuiAlert-icon": {
            color: "#fff",
            fontSize: "1.5rem",
            mr: 1.5,
          },
          "& .MuiAlert-action": {
            color: "#f8fafc",
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
